import { isExpEditor } from '../lib/lib'
import Swiper from 'swiper/bundle'

class bannerSwiper {
  constructor(element) {
    if (!element) {
      return false
    }

    if (isExpEditor()) {
      return false
    }

    this.slidesElementsLength =
      element.getElementsByClassName('swiper-slide').length

    this.slidesLength =
      this.slidesElementsLength > 2 ? 3 : this.slidesElementsLength

    this.swiperElement = element.getElementsByClassName('swiper')[0]

    if (this.slidesLength === 1) {
      this.swiperElement.classList.add('no-init')
      return
    }

    this.swiperElement.style.maxWidth = ` calc(356px * ${
      this.slidesLength
    } + 32px * ${this.slidesLength - 1})`

    this.strip = jQuery(element)

    const swiper = new Swiper(this.strip.find('.swiper')[0], {
      direction: 'horizontal',
      effect: 'slide',
      slidesPerView: 3,
      centeredSlides: false,
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 8,
        },
        576: {
          slidesPerView: 1.75,
          spaceBetween: 8,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        992: {
          slidesPerView: this.slidesLength,
          spaceBetween: 16,
        },
      },
      pagination: {
        el: this.strip.find('.swiper-pagination')[0],
        type: 'bullets',
        clickable: true,
      },
    })
  }
}

export default bannerSwiper
